<script>
import axios from "axios";
import moment from "moment";
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { authFackMethods } from "@/state/helpers";

export default {
  page: {
    title: "Assignment Approver",
    meta: [
      {
        name: "Assignment Approver",
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      preservePage: 1,
      pageLimit: 50,
      assignmentApprovers: {},
      currentUserData: JSON.parse(localStorage.getItem("user")),
      typeSubmit: false,
      isLoading: false,
      noRecord: false,
    };
  },
  mounted() {
    this.getAssignmentApprover();
  },
  filters: {
    moment: function (date) {
      if (date === null) {
        return "";
      }
      return moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
    },
  },
  methods: {
    getAssignmentApprover(page) {
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.preservePage = page;
      let filter = "&per_page=" + this.pageLimit;
      //if not admin
      if (this.currentUserData.user_type_id !== 1) {
        filter += "&locations=yes";
        filter += "&user_id=" + this.currentUserData.id;
      }

      axios
        .get(
          "admin/assignments?status=awaiting_approval&pagination=true&page=" +
            page +
            filter
        )
        .then((res) => {
          this.assignmentApprovers = res.data.response;
          this.isLoading = false;
          if (!this.assignmentApprovers.data.length) {
            this.noRecord = true;
            if (page > 1) {
              this.getAssignmentApprover(page - 1);
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.logout();
            }
          }
        });
    },
    ...authFackMethods,

    approveAssignment(id) {
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to approve this Assignment!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Approve it!",
      }).then((result) => {
        if (result.value) {
          if (token) {
            axios
              .get(
                "admin/schedule/update/status/" + id + "?status=active",
                config
              )
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Approved!",
                    text: "Assignment has been Approved!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getAssignmentApprover();
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      });
    },

    rejectAssignment(id) {
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel this Assignment!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Cancel it!",
      }).then((result) => {
        if (result.value) {
          if (token) {
            axios
              .get(
                "admin/schedule/update/status/" + id + "?status=cancelled",
                config
              )
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Rejected!",
                    text: "Assignment has been Cancelled!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getAssignmentApprover();
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      });
    },

    approveBulk() {
      console.log(this.assignmentApprovers.data);
      let ids = this.assignmentApprovers.data.map((item) => item.id).join(",");

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to approve all the Assignments?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Approve it!",
      }).then((result) => {
        if (result.value) {
          if (token) {
            axios
              .get(
                "admin/schedule/update/status_bulk?status=active&ids=" + ids,
                config
              )
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Approved!",
                    text: "Assignment(s) have been Approved!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getAssignmentApprover();
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      });
    },

    deleteAssignment(id) {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      };
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this Assignment!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Remove it!",
      }).then((result) => {
        if (result.value) {
          if (token) {
            axios
              .delete("admin/schedule/" + id, config)
              .then((res) => {
                if (res.status == "200") {
                  Swal.fire({
                    title: "Canceled!",
                    text: "Assignment has been Deleted!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.getAssignmentApprover();
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Assignment Approver</h5>
          </div>
          <div class="mb-4 mdl-btns ms-auto">
            <!--Add Assignment Modal-->
            <b-button
              v-if="
                assignmentApprovers.data && assignmentApprovers.data.length > 0
              "
              @click="approveBulk"
              variant="primary"
              >Approve All</b-button
            >
          </div>
        </div>

        <div class="table-responsive">
          <table
            class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0"
          >
            <thead class="table-light">
              <tr>
                <th scope="col">Volunteer</th>
                <th scope="col">Roles</th>
                <th scope="col">Date</th>
                <th scope="col">Time Slot</th>
                <!-- <th scope="col">Department</th> -->
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="7" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>

              <tr v-if="isLoading">
                <td colspan="7" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>

              <tr
                v-else
                v-for="(schedule, index) in assignmentApprovers.data"
                :key="index"
              >
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    <router-link
                      tag="a"
                      :to="`/registration-progress/user/${schedule.user_id}`"
                    >
                      {{ schedule.volunteer_name }}
                    </router-link>
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ schedule.role }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    <!-- {{new Date(schedule.date).toLocaleString().split(',')[0]}} -->
                    {{ schedule.date | moment }}
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    {{ schedule.start_time }} to {{ schedule.end_time }}
                  </h5>
                </td>
                <!-- <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{schedule.department}}
                </h5>
              </td> -->
                <td>
                  <h5 class="font-size-13 text-truncate mb-1 text-capitalize">
                    {{ schedule.status.replace(/_/g, " ") }}
                  </h5>
                </td>
                <td>
                  <b-button
                    id="show-btn"
                    :class="schedule.status != 'cancelled' ? '' : 'disabled'"
                    @click="approveAssignment(schedule.id)"
                    variant="primary"
                    title="Edit"
                  >
                    <i class="bx bxs-check-circle"></i>
                  </b-button>
                  <b-button
                    class="ms-2"
                    @click="rejectAssignment(schedule.id)"
                    variant="primary"
                    title="Cancel"
                  >
                    <i class="bx bx-x"></i>
                  </b-button>
                  <!-- <b-button class="ms-2" @click="deleteAssignment(schedule.id)" variant="primary" title="Check Status">
                  <i class="bx bxs-trash-alt"></i>
                </b-button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination
          class="mt-4"
          :data="assignmentApprovers"
          :limit="10"
          @pagination-change-page="getAssignmentApprover"
        ></pagination>
      </div>
    </div>
  </Layout>
</template>
